import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./imageslider.css";
import { fetchProducts, fetchProductById } from '../../services/getProducts';
import { FaShoppingCart } from "react-icons/fa";

const data = [
  {
    name: "Arduino UNO R4 WIFI",
    img: "/images/R4.png",
    review: "La nueva placa UNO mucho mejor y más completa a tu alcance. Todo lo que necesitas para evolucionar tus proyectos.",
    price: "$29.99",
    quantity: 5
  },
  {
    name: "Kit de Arduino ULTIMATE",
    img: "/images/ultima.jpg",
    review: "El Kit de Arduino Ultimate lleva la experiencia de programar con Arduino a un nuevo nivel.",
    price: "$49.99",
    quantity: 3
  },
  {
    name: "Superior ESP",
    img: "/images/ESP_Caja.png",
    review: "El Superior ESP nace del acople del ESP32 tradicional con una placa de expansión que le brinda una mayor autonomía y amplía sus posibilidades.",
    price: "$39.99",
    quantity: 7
  },
  {
    name: "Kit de puentes",
    img: "/images/puentes.jpg",
    review: "Este kit incluye 140 cables precortados de diferentes tamaños y colores, perfecto para protoboard.",
    price: "$19.99",
    quantity: 10
  },
  {
    name: "Sensor ultrasónico",
    img: "/images/ultra.jpg",
    review: "Módulo capaz de medir distancias por medio de ultrasonidos.",
    price: "$9.99",
    quantity: 15
  },
];

const ImageSlider = () => {
  const [products, setProducts] = useState([]);
  const [update, setUpdate] = useState('');
  const [id, setId] = useState('');
  const [query, setQuery] = useState('');
  const [isEdgeTransition, setIsEdgeTransition] = useState(false);

  useEffect(() => {
    // Función para cargar los productos
    const loadProducts = async () => {
      const data = await fetchProducts(update, id, query);
      setProducts(data); // Actualiza los productos
    };
    loadProducts();
  }, [update, id, query]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000, // Ajusta la velocidad para un efecto más fluido
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true, // Habilita el modo centrado
    centerPadding: "10px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleBeforeChange = (oldIndex, newIndex) => {
    // Detecta cuando se da la transición del primer al último o viceversa
    if ((oldIndex === 0 && newIndex === data.length - 1) || (oldIndex === data.length - 1 && newIndex === 0)) {
      setIsEdgeTransition(true);
    } else {
      setIsEdgeTransition(false);
    }
  };

  const handleCartClick = (item) => {
    // Placeholder for cart action
    console.log("Cart clicked for:", item.name);
  };

  return (
      <div className={`slider-wrapper ${isEdgeTransition ? "edge-transition" : ""}`}>
        <h1>Productos Destacados</h1>
        <Slider {...settings} beforeChange={handleBeforeChange}>
          {data.map((item, index) => (
              <div key={index} className="slider-item">
                <div className="image-container">
                  <img src={item.img} alt={item.name} />
                </div>
                <div className="item-content">
                  <h3>{item.name}</h3>
                  <p>{item.review}</p>
                  <div className="cart-container">
                    <button className="cart-button" onClick={() => handleCartClick(item)}>
                      <FaShoppingCart />
                    </button>
                    <div className="product-details">
                      <span className="price">{item.price}</span>
                      <span className="quantity">Qty: {item.quantity}</span>
                    </div>
                  </div>
                </div>
              </div>
          ))}
        </Slider>
      </div>
  );
};

export default ImageSlider;
